"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailSendMultiplierSelector = exports.minPurchasableContactsSelector = exports.purchasedContactsQuantitySelector = exports.purchasedMarketingContactsQuantitySelector = exports.purchasedMarketingContactsQuantityForPlanSelector = exports.contactsQuantityMultiplierSelector = exports.numContactsInCrmSelector = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reselect = require("reselect");

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var _ParcelQuantityMap = require("self-service-api/constants/ParcelQuantityMap");

var _RequestStatusTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/RequestStatusTypes"));

var _ScopeSelectors = require("pricing-pages-unified-ui/selectors/ScopeSelectors");

var numContactsInCrmSelector = function numContactsInCrmSelector(state) {
  var numContactsInCrm = state.numContactsInCrm;

  if (numContactsInCrm === _RequestStatusTypes.default.FAILED) {
    var isDevPortal = (0, _ScopeSelectors.isDevPortalSelector)(state); // If we weren't able to get contacts, they don't have CRM access, and the can't purchase anyway
    // just show the pricing page with 0 contacts

    if (isDevPortal) {
      return 0;
    }
  }

  return numContactsInCrm;
}; // Returns the contacts quantity multiplier for the additionalUnitMerchId of the activeMerchId


exports.numContactsInCrmSelector = numContactsInCrmSelector;
var contactsQuantityMultiplierSelector = (0, _reselect.createSelector)([_MerchandiseSelectors.merchandiseSelector, function (_, merchandiseId) {
  return merchandiseId;
}], function (merchandise, merchandiseId) {
  if (!merchandise || !merchandiseId) return null;
  var additionalUnitMerchId = merchandise[merchandiseId].additionalUnitMerchId;

  if (!additionalUnitMerchId) {
    if ('quantityMultiplier' in merchandise[merchandiseId]) {
      return merchandise[merchandiseId].quantityMultiplier;
    }

    return null;
  }

  return merchandise[additionalUnitMerchId].quantityMultiplier;
});
exports.contactsQuantityMultiplierSelector = contactsQuantityMultiplierSelector;

var _purchasedContactsQuantitySelector = function _purchasedContactsQuantitySelector(state, parcelMultiplierMap) {
  var parcelName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var parcels = (0, _ProductOwnershipSelectors.parcelsSelector)(state);
  var parcelMap = parcels.reduce(function (acc, parcel) {
    return Object.assign({}, acc, (0, _defineProperty2.default)({}, parcel.parcelName, parcel));
  }, {});
  var parcelNameToUse;

  if (parcelName) {
    parcelNameToUse = parcelName;
  } else {
    // If we aren't passed a specific parcelName, try to find the highest priority
    // parcel to use (the one associated with the highest edition marketing plan you have parcels for)
    parcelNameToUse = Object.keys(parcelMultiplierMap).reverse().find(function (searchParcelName) {
      return searchParcelName in parcelMap;
    });
  }

  var parcel = parcelMap[parcelNameToUse];

  if (parcel && parcelNameToUse in parcelMultiplierMap) {
    return parcel.quantity * parcelMultiplierMap[parcelNameToUse];
  }

  return 0;
};

var purchasedMarketingContactsQuantityForPlanSelector = function purchasedMarketingContactsQuantityForPlanSelector(baseMarketingMerchId) {
  return function (state) {
    var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
    var additionalUnitMerchId = merchandiseMap[baseMarketingMerchId].additionalUnitMerchId;
    var parcelName = merchandiseMap[additionalUnitMerchId].parcelName;
    return _purchasedContactsQuantitySelector(state, _ParcelQuantityMap.MARKETING_CONTACTS_QUANTITIES, parcelName);
  };
}; // returns amount of marketing contacts a user has purchased


exports.purchasedMarketingContactsQuantityForPlanSelector = purchasedMarketingContactsQuantityForPlanSelector;

var purchasedMarketingContactsQuantitySelector = function purchasedMarketingContactsQuantitySelector(state) {
  return _purchasedContactsQuantitySelector(state, _ParcelQuantityMap.MARKETING_CONTACTS_QUANTITIES);
}; // returns amount of contacts a user has purchased


exports.purchasedMarketingContactsQuantitySelector = purchasedMarketingContactsQuantitySelector;

var purchasedContactsQuantitySelector = function purchasedContactsQuantitySelector(state) {
  return _purchasedContactsQuantitySelector(state, _ParcelQuantityMap.CONTACTS_QUANTITIES);
}; // returns minimum amount of contacts a user can buy


exports.purchasedContactsQuantitySelector = purchasedContactsQuantitySelector;
var minPurchasableContactsSelector = (0, _reselect.createSelector)([_MerchandiseSelectors.merchandiseSelector, function (_, merchandiseId) {
  return merchandiseId;
}, numContactsInCrmSelector, _MarketingContactsSelectors.marketingContactsOnRenewalSelector, contactsQuantityMultiplierSelector, purchasedContactsQuantitySelector, purchasedMarketingContactsQuantitySelector, _MerchandiseSelectors.isMarketingContactsSKUSelector], function (merchandise, merchandiseId, numContactsInCrm, marketingContactsOnRenewal, contactsQuantityMultiplier, purchasedContactsQuantity, purchasedMarketingContactsQuantity, isMarketingContactsSKU) {
  // missing information in state
  if (numContactsInCrm === null || isMarketingContactsSKU && marketingContactsOnRenewal === null || !contactsQuantityMultiplier || !merchandiseId) {
    return null;
  }

  var includedAdditionalUnits = merchandise[merchandiseId].includedAdditionalUnits;

  if (isMarketingContactsSKU) {
    var billableAdditionalContacts = Math.max(0, marketingContactsOnRenewal - includedAdditionalUnits);
    return Math.ceil(Math.max(billableAdditionalContacts, purchasedMarketingContactsQuantity) / contactsQuantityMultiplier) * contactsQuantityMultiplier;
  } else {
    // hasn't bought contacts before
    if (!purchasedContactsQuantity) {
      // contacts in crm is fewer than minimum contacts purchase quantity
      if (numContactsInCrm < includedAdditionalUnits) {
        return includedAdditionalUnits;
      } // contacts in crm is fewer than quantity multiplier


      if (numContactsInCrm <= contactsQuantityMultiplier) {
        return contactsQuantityMultiplier;
      }
    }

    var purchasableContactsFromCrm = Math.ceil(numContactsInCrm / contactsQuantityMultiplier) * contactsQuantityMultiplier;
    return Math.max(purchasableContactsFromCrm, purchasedContactsQuantity);
  }
});
exports.minPurchasableContactsSelector = minPurchasableContactsSelector;

var emailSendMultiplierSelector = function emailSendMultiplierSelector(state, merchandiseId) {
  var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);

  if (!merchandise || !merchandiseId) {
    return null;
  }

  var limits = merchandise[merchandiseId].limits;
  var emailSendLimitObject = limits.filter(function (limit) {
    return limit.name === 'email_sends';
  });

  if (emailSendLimitObject.length === 0) {
    return null;
  }

  var emailSendLimit = emailSendLimitObject[0].limit;
  var quantityMultiplier = contactsQuantityMultiplierSelector(state, merchandiseId);
  return emailSendLimit / quantityMultiplier;
};

exports.emailSendMultiplierSelector = emailSendMultiplierSelector;